export default __webpack_public_path__ + "static/icon-tile-bold-do-ce32f8d653b18aca67527861cc89de8e.png";